import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

interface DeleteTicketDialogProps {
  open: boolean;
  onClose: () => void;
  handleDelete: () => void;
  isDeleting: boolean;
}

function DeleteTicketDialog({
  open,
  onClose,
  handleDelete,
  isDeleting,
}: DeleteTicketDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className='max-w-sm py-8'
        onOpenAutoFocus={(e) => e.preventDefault()}
        hideClose
      >
        <DialogHeader className='flex flex-col items-center justify-center w-full gap-y-2'>
          <DialogTitle>{t('delete_ticket')}</DialogTitle>
          <DialogDescription className='text-base font-medium'>
            {t('delete_ticket_confirmation')}
          </DialogDescription>
        </DialogHeader>

        <div className='flex items-center justify-center gap-4 mt-4'>
          <Button
            type='button'
            onClick={handleDelete}
            className='px-6 h-9 bg-rose-500 hover:bg-rose-500/90'
            disabled={isDeleting}
          >
            {isDeleting ? (
              <Loader2 className='w-4 h-4 mr-2 animate-spin' />
            ) : null}
            {t('delete')}
          </Button>
          <Button
            type='button'
            variant='outline'
            onClick={onClose}
            className='px-6 text-gray-500 border-gray-400 h-9 hover:bg-transparent hover:text-gray-500'
          >
            {t('cancel')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteTicketDialog;
